var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86821 0.327061C8.69248 0.151315 8.40757 0.151315 8.23181 0.327061L2.84053 5.7184L0.768208 3.64607C0.592479 3.47033 0.307573 3.47035 0.13181 3.64607C-0.0439365 3.8218 -0.0439365 4.10671 0.13181 4.28246L2.52233 6.67294C2.698 6.84867 2.98312 6.84855 3.15873 6.67294L8.86821 0.963459C9.04395 0.787731 9.04394 0.502807 8.86821 0.327061Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTik);
export default __webpack_public_path__ + "static/media/tik.fd5e95023d437dcba36f4ffa641c10f1.svg";
export { ForwardRef as ReactComponent };